import { render, staticRenderFns } from "./PermissionGate.vue?vue&type=template&id=9d6112cc"
import script from "./PermissionGate.vue?vue&type=script&lang=js"
export * from "./PermissionGate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports